<template>
  <div class="row">
    <kotsuhi-menu></kotsuhi-menu>
    <div class="col-md-10 pt-3" v-if="hasAnyRole('ROLE_ADMIN','ROLE_KOTSUHI_READ','ROLE_KOTSUHI_ADMIN')">
      <div>
          <div class="form-group">
              <span style="margin-left:15px;">年</span>
              <select class="search-select custom-select" name="year" v-model="selectedYear" @change="changeSelected">
                  <option v-for="year in yearList" :value="year" :key="year">
                          {{year}}
                  </option>
              </select>
              <span style="margin-left:15px;">月</span>
              <select class="search-select custom-select" name="month" v-model="selectedMonth" @change="changeSelected">
                  <option v-for="month in 12" :value="month" :key="month">
                          {{month}}
                  </option>
              </select>
              <span style="margin-left:15px;">部署</span>
              <select class="search-select custom-select" name="department" v-model="selectedDepartmentId" @change="changeSelected">
                  <option value="" selected="selected" v-if="hasAnyRole('ROLE_ADMIN', 'ROLE_MANAGE')">すべて</option>
                  <option v-for="(current, index) in loginUser.departmentList" :value="loginUser.departmentIdList[index]" :key="index">
                          {{current}}
                  </option>
              </select>
              <span style="margin-left:5px;">ユーザ</span>
              <select class="search-select custom-select" name="userId" v-model="selectedUserId" @change="changeSelected">
                  <option selected="true"></option>
                  <option v-for="user in userList" :value="user.userId" :key="user.userId" v-if="!isRetiree(user.deletedAt)">
                    {{user.userName}}
                  </option>
              </select>
              <span style="margin-left:5px;">ステータス</span>
              <select class="search-select custom-select" name="status" v-model="selectedStatus" @change="changeSelected">
                  <option selected="true"></option>
                  <option v-for="status in statusList" :value="status" :key="status">
                    {{status}}
                  </option>
              </select>
          </div>
      </div>
      <button v-if="hasAnyRole('ROLE_ADMIN','ROLE_KOTSUHI_ADMIN')" id="kotsuhiBulkApproval" class="btn btn-primary btn-sm m-1" disabled="disabled" @click="bulkConfirm()">
        一括承認
      </button>
      <button v-if="hasAnyRole('ROLE_ADMIN','ROLE_KOTSUHI_ADMIN')" id="kotsuhiBulkPaid" class="btn btn-success btn-sm" disabled="disabled" @click="bulkPaidConfirm()">
        一括精算
      </button>
      <modal ref="bulkConfirm" @ok="bulkStatusUpdate('confirm')"></modal>
      <modal ref="bulkPaid" @ok="bulkStatusUpdate('paid')"></modal>

      <span v-if="containPaid" class="text-danger">*すでに精算済みのものはステース変更されません。</span>
      <div v-if="kotsuhiList.length == 0">まだレコードはありません</div>
      <div v-else>
          <table class="table table-bordered table-responsive">
              <thead class="thead-light">
              <tr>
                  <th>
                    <div class="checkbox noflap">
                      <label>
                          <input type="checkbox" id="kotsuhiAllCheck" @click="checkAll">
                          <span class="checkbox-material"><span class="check"></span></span></input>
                      </label>
                    </div>
                  </th>
                  <th>氏名</th>
                  <th>対象日</th>
                  <th>出発駅</th>
                  <th>到着駅</th>
                  <th>使用路線</th>
                  <th>料金種類</th>
                  <th>利用用途</th>
                  <th>費用</th>
                  <th>ステータス</th>
                  <th v-if="hasAnyRole('ROLE_ADMIN','ROLE_KOTSUHI_ADMIN')">承認/取消</th>
                  <th>申請日</th>
                  <th>申請書(EXCEL)</th>
                  <th v-if="hasAnyRole('ROLE_ADMIN','ROLE_KOTSUHI_ADMIN')">削除</th>
              </tr>
              </thead>
              <tbody>
                  <tr v-for="(result, index) in kotsuhiList" :key="index" :class="{'retiree': result.userDeletedAt}">
                      <td>
                          <div class="checkbox noflap">
                              <label>
                                  <input class="kotsuhiCheck" type="checkbox" name="idList" :value="result.id" :data-status="result.status" @click="checkSingle">
                                  <span class="checkbox-material"><span class="check"></span></span></input>
                              </label>
                          </div>
                      </td>
                      <td>
                          {{result.userName}}
                          <span v-if="result.userDeletedAt" class="badge badge-secondary">退職</span>
                      </td>
                      <td>{{result.targetDate}}</td>
                      <td>{{result.startStation}}</td>
                      <td>{{result.endStation}}</td>
                      <td>{{result.route}}</td>
                      <td>{{result.type}}</td>
                      <td>{{result.useType}}</td>
                      <td>{{result.expense}}</td>
                      <td>{{result.status}}</td>
                      <td v-if="hasAnyRole('ROLE_ADMIN','ROLE_KOTSUHI_ADMIN')">
                          <div v-if="hasAnyRole('ROLE_ADMIN','ROLE_YUKYU_ADMIN')">
                              <div v-if="result.status==='申請中' || result.status==='差し戻し'">
                                  <button type="button" class="btn btn-primary btn-sm" @click="updateStatus('confirm', result.id)">承認</button>
                              </div>
                              <div v-if="result.status==='承認済み'">
                                  <button type="button" class="btn btn-sm btn-success" @click="updateStatus('paid', result.id)">精算</button>
                                  <button type="button" class="btn btn-sm btn-outline-dark" @click="updateStatus('remand', result.id)">差し戻し</button>
                              </div>
                              <div v-if="result.status==='精算済み'">
                                  <i class="fa fa-check fa-1x" aria-hidden="true"></i>
                              </div>
                          </div>
                      </td>
                      <td>{{result.createdDate}}</td>
                      <td>
                          <button type="button" class="btn btn-info" style="border-radius: 50px;" @click="download(`/api/kotsuhi/download/${selectedYear}/${selectedMonth}/${result.userId}/excel`)">
                              ダウンロード
                          </button>
                      </td>
                      <td v-if="hasAnyRole('ROLE_ADMIN','ROLE_KOTSUHI_ADMIN')">
                          <div v-if="hasAnyRole('ROLE_ADMIN','ROLE_YUKYU_ADMIN')">
                              <button type="button" class="btn btn-outline-danger btn-sm" data-toggle="modal" :data-target="'#' + result.id">
                                  <i class="fa fa-trash fa-1x" aria-hidden="true"></i>
                                  削除
                              </button>
                          </div>
                          <!-- Modal -->
                          <div class="modal fade" :id="result.id" tabindex="-1"
                              role="dialog" aria-labelledby="exampleModal3Label" aria-hidden="true">
                              <div class="modal-dialog" role="document">
                                  <div class="modal-content">
                                      <div class="modal-header">
                                          <h5 class="modal-title" id="exampleModal3Label">確認</h5>
                                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                              <span aria-hidden="true">×</span>
                                          </button>
                                      </div>
                                      <div class="modal-body">
                                          名前
                                          <p>{{result.userName}}</p>
                                          対象日
                                          <p>{{result.targetDate}}</p>
                                          本当に削除してもよろしいですか？
                                      </div>
                                      <div class="modal-footer">
                                          <button type="button" class="btn btn-secondary" data-dismiss="modal">キャンセル</button>
                                          <button type="button" class="btn btn-danger" @click="kotsuhiDelete(result.id)">削除</button>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </td>
                  </tr>
              </tbody>
          </table>
      </div>
      <div class="text-right">
        <pagination v-if="kotsuhiList.length > 0" :pagination="pagination"></pagination>
      </div>
    </div>
  </div>
</template>

<style scoped>
.noflap{
 white-space: nowrap;
}
.retiree{
  background: #ccc !important;
}
a {
	text-decoration: none;
	color: white;
}
</style>

<script>
import KotsuhiAPI from '../../../api/kotsuhi-api'
import UserAPI from '../../../api/user-api'
import moment from 'moment'
import KotsuhiMenu from './KotsuhiMenu.vue'
import Pagination from '../../Pagination.vue'
import Modal from '../../Modal.vue'

export default {
  name: "kotsuhi-list",
  components: {
    KotsuhiMenu,
    Pagination,
    Modal
  },
  data() {
    return {
      loginUser: {
        role: ''
      },
      containPaid: false,
      yearList: [],
      userList: [],
      statusList: ['申請中', '差し戻し', '未精算', '承認済み', '精算済み'],
      kotsuhiList: [],
      selectedYear: moment().format("YYYY"),
      selectedMonth: moment().format("M"),
      selectedDepartmentId: '',
      selectedUserId: '',
      selectedStatus: '',
      dispMaxSize: 20,
      pagination: {
        // 現在ページ
        currentPage: 0,
        // 最大表示ページ件数
        dispMaxPageSize: 5,
        // トータルページ数
        totalPages: 0
      }
    }
  },
  watch: {
    '$root.$refs.asnHeader.$data.loginUser': function (val) {
        this.loginUser = this.$root.$refs.asnHeader.$data.loginUser
        if(!this.hasAnyRole('ROLE_ADMIN', 'ROLE_MANAGE')){
            this.selectedDepartmentId = this.loginUser.departmentIdList.length > 0 ? this.loginUser.departmentIdList[0] : ''
        }
        this.getKotsuhiList()
        this.getUserList()
        this.getYearList()
    },
    // ページ移動を検知
    'pagination.currentPage': function (val) {
      this.getKotsuhiList()
    }
  },
  mounted () {
    if (this.$route.query.year) {
        this.selectedYear = this.$route.query.year
    }
    if (this.$route.query.month) {
        this.selectedMonth = this.$route.query.month
    }
    if (this.$route.query.departmentId){
        this.selectedDepartmentId = this.$route.query.departmentId;
    }
    if (this.$route.query.userId){
        this.selectedUserId = this.$route.query.userId;
    }
    if (this.$route.query.status){
        this.selectedStatus = this.$route.query.status;
    }
  },
  methods: {
    // ユーザリスト取得
    getUserList () {
      let params = {
        departmentId: this.selectedDepartmentId,
      }
      UserAPI.getUserList(params)
        .then(res => {
            this.userList = res
        })
        .catch(err => {
            console.error(err)
        })
    },
    // 年一覧取得
    getYearList () {
      KotsuhiAPI.getYearList()
        .then(res => {
            this.yearList = res
        })
        .catch(err => {
            console.error(err)
        })
    },
    // 交通費一覧取得
    async getKotsuhiList () {
        this.$root.$refs.loading.$data.show = true
        let params = {}
        params['year'] = this.selectedYear
        params['month'] = this.selectedMonth
        params['departmentId'] =  this.selectedDepartmentId
        params['userId'] =  this.selectedUserId
        params['status'] = this.selectedStatus
        params['pageSize'] = this.dispMaxSize
        params['pageNo'] = this.pagination.currentPage ? this.pagination.currentPage : 0
        const res = await KotsuhiAPI.getKotsuhiList(params)
        if (res.content){
            this.pagination.totalPages = res.totalPages
            this.kotsuhiList = res.content
        } else {
            this.pagination.totalPages = 0
            this.pagination.currentPage = 0
            this.kotsuhiList = []
        }
        this.$nextTick(function() {
            $(".close").click()
            this.$root.$refs.loading.$data.show = false
        })
    },
    // 交通費ステータス更新
    updateStatus (status, id) {
        this.$root.$refs.loading.$data.show = true
        KotsuhiAPI.updateStatus(status, id)
            .then(res => {
                this.$router.go({
                    path: this.$router.path,
                    query: {
                        t: + new Date()
                    }
                })
            })
            .catch(err => {
                console.error(err)
                this.$root.$refs.loading.$data.show = false
            })
    },
    // 交通費削除
    kotsuhiDelete (id) {
      this.$root.$refs.loading.$data.show = true
      KotsuhiAPI.delete(id)
        .then(res => {
            this.$root.$refs.loading.$data.show = false
            this.getKotsuhiList()
        })
        .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
        })
    },
    // 全てチェック・外す
    checkAll (){
      const boxCnt = $(".kotsuhiCheck").length;
      if($(".kotsuhiCheck:checked").length === boxCnt){
          $(".kotsuhiCheck").prop("checked",false);
          $("#kotsuhiBulkApproval").prop("disabled",true);
          $("#kotsuhiBulkPaid").prop("disabled",true);
      }else{
          $(".kotsuhiCheck").prop("checked",true);
          $("#kotsuhiBulkApproval").prop("disabled",false);;
          $("#kotsuhiBulkPaid").prop("disabled",false);
      }
      // 一括精算ボタンの制御
      this.checkStatus()
    },
    // 個別チェック
    checkSingle () {
      let boxCnt = $(".kotsuhiCheck").length;
      if($(".kotsuhiCheck:checked").length !== boxCnt){
          $("#kotsuhiAllCheck").prop("checked",false);
      }else{
          $("#kotsuhiAllCheck").prop("checked",true);
      }
      if($(".kotsuhiCheck:checked").length > 0){
          $("#kotsuhiBulkApproval").prop("disabled",false);
          $("#kotsuhiBulkPaid").prop("disabled",false);
      }else{
          $("#kotsuhiBulkApproval").prop("disabled",true);
          $("#kotsuhiBulkPaid").prop("disabled",true);
      }
      // 一括精算ボタンの制御
      this.checkStatus()
    },
    // 一括承認確認
    bulkConfirm(){
        this.$refs.bulkConfirm.confirm("選択した申請を承認します")
    },
    // 一括承認確認
    bulkPaidConfirm(){
        this.$refs.bulkPaid.confirm("選択した申請を精算済みにします")
    },
    // ステータス一括更新
    bulkStatusUpdate (status) {
      this.$root.$refs.loading.$data.show = true
      let keyList = [];
      $(".kotsuhiCheck:checked").each(function(index, element){
          if(status == 'paid') {
              if(this.isUnapproved(element.dataset.status)){
                alert("未承認が含まれている場合、精算できません")
                return 
              }
          }
          keyList.push(element.value);
      }.bind(this))
      KotsuhiAPI.bulkStatusUpdate(status, keyList)
        .then(res => {
            this.$router.go({
                path: this.$router.path,
                query: {
                    t: + new Date()
                }
            })
        })
        .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
        })
    },
    // 権限を持っているか判定
    hasAnyRole: function (...args) {
        for (var i = 0; i < arguments.length; i++) {
            if (this.loginUser.role.includes(arguments[i])) {
                return true
            }
        }
        return false
    },
    // 未承認判定
    isUnapproved (status) {
        if(status == '承認済み' || status == '精算済み') {
            return false
        }
        return true
    },
    // チェックした中に未承認が含まれているか確認
    checkStatus() {
        this.containPaid = false
        $(".kotsuhiCheck:checked").each(function(index, element){
            if(element.dataset.status == '精算済み'){
                this.containPaid = true
            }
            if(this.isUnapproved(element.dataset.status)){
                $("#kotsuhiBulkPaid").prop("disabled",true);
            }
        }.bind(this))
    },
    // セレクト変更時
    changeSelected () {
        // 履歴を追加
        this.$router.push("/admin/kotsuhi/top/?year=" + this.selectedYear + '&month=' + this.selectedMonth + '&userId=' + this.selectedUserId + '&status=' + this.selectedStatus)
        // データの再取得
        this.getKotsuhiList()
    },
    // 退職済みか
    isRetiree(deletedAt){
        if(deletedAt){
            var ym = moment().set('year', this.selectedYear).set('month', this.selectedMonth - 1).set('date', 1).format("YYYY-MM-DD")
            return moment(deletedAt).isBefore(ym)
        }
        return false
    },
    /**
     * Excelダウンロード
     */
    download (url) {
        location.href = url
    }
  },
  filters: {
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/admin/kotsuhi/KotsuhiList.vue